import Box from '@mui/material/Box';

/**
 * Holds reCAPTCHA's exact space (its widget is 304×78) until the real widget is on screen, so
 * nothing shifts when it appears. It uses the same `captcha-input` class and inner <div> as the
 * real widget, so the global scale/height rules for `.google-recaptcha` / `.captcha-input` size it
 * identically at every breakpoint.
 */
const CaptchaPlaceholder = () => (
    <div className="captcha-input" aria-hidden="true">
        <div style={{width: 304, height: 78}} />
    </div>
);

/** Reserves the captcha's space while its code is still downloading (the `dynamic()` loading state). */
export const CaptchaSlot = () => (
    <Box className="google-recaptcha">
        <CaptchaPlaceholder />
    </Box>
);

export default CaptchaPlaceholder;
